<template>
  <div
  v-bind:style="{
    'font-size': widthInCustomMetric ? widthInCustomMetric : width + 'px',
    'color': color
  }"
  class="comp-icon">
    <template v-if="icon === 'sdCard'">
      <svg fill="#FFFFFF" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 0h24v24H0z" fill="none"/>
        <path d="M18 2h-8L4.02 8 4 20c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 6h-2V4h2v4zm3 0h-2V4h2v4zm3 0h-2V4h2v4z"/>
      </svg>
    </template>
    <template v-else-if="icon === 'bridge'">
      <svg fill="#000000" height="48px" viewBox="0 0 24 24" width="48px" xmlns="http://www.w3.org/2000/svg">
        <rect height="18" width="17" x="3.5" y="3" rx="1" ry="1"></rect>
        <rect fill="hsl(100, 100%, 0%)" height="2" width="2" x="4.75" y="14"></rect>
        <rect fill="hsl(200, 100%, 0%)" height="2" width="2" x="7.25" y="14"></rect>
        <rect fill="hsl(0, 100%, 0%)" height="2" width="2" x="9.75" y="14"></rect>
        <rect fill="hsl(0, 100%, 0%)" height="2" width="2" x="12.25" y="14"></rect>
        <rect fill="hsl(0, 100%, 0%)" height="2" width="2" x="14.75" y="14"></rect>
        <rect fill="hsl(0, 100%, 0%)" height="2" width="2" x="17.25" y="14"></rect>
      </svg>
    </template>
    <template v-else-if="icon === 'chekt'">
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid meet" viewBox="0 0 640 640" width="48" height="48"><defs><path d="M330.5 18.09L337.89 18.25L345.28 18.47L352.67 18.75L360.08 19.1L367.48 19.52L374.9 19.99L382.31 20.53L389.74 21.13L397.17 21.8L404.6 22.53L412.04 23.33L419.49 24.18L426.94 25.1L434.4 26.09L441.86 27.14L449.33 28.25L456.8 29.42L464.28 30.66L471.77 31.96L479.26 33.33L486.75 34.76L494.25 36.25L501.76 37.8L509.27 39.42L516.79 41.11L524.31 42.85L531.84 44.66L539.38 46.53L546.92 48.47L554.46 50.47L562.01 52.54L569.57 54.66L577.13 56.85L584.7 59.11L592.27 61.43L599.85 63.81L607.44 66.25L615.03 68.76L615.47 79.36L615.8 89.86L616.04 100.28L616.16 110.6L616.19 120.84L616.1 130.98L615.92 141.04L615.63 151L615.23 160.87L614.73 170.66L614.13 180.35L613.42 189.95L612.6 199.46L611.68 208.88L610.66 218.21L609.53 227.46L608.3 236.61L606.96 245.67L605.52 254.63L603.97 263.51L602.32 272.3L600.56 281L598.7 289.61L596.73 298.13L594.66 306.55L592.49 314.89L590.21 323.14L587.83 331.29L585.34 339.36L582.74 347.33L580.04 355.22L577.24 363.01L574.33 370.72L571.32 378.33L568.2 385.86L564.98 393.29L561.66 400.63L558.22 407.88L554.69 415.05L551.05 422.12L549.49 425.05L547.83 428.09L546.07 431.21L544.22 434.43L542.28 437.74L540.23 441.13L538.08 444.6L535.83 448.15L533.48 451.78L531.02 455.48L528.46 459.25L525.79 463.08L523.01 466.98L520.13 470.94L517.13 474.95L514.02 479.02L510.8 483.14L507.47 487.31L504.02 491.52L500.45 495.77L496.76 500.07L492.96 504.39L489.04 508.75L484.99 513.14L480.82 517.55L476.53 521.99L472.11 526.44L467.56 530.91L462.89 535.4L458.09 539.9L453.16 544.4L448.09 548.91L442.89 553.41L437.56 557.92L432.1 562.42L426.5 566.91L420.76 571.39L414.88 575.86L408.86 580.31L402.7 584.74L400.88 586.01L399.04 587.27L397.19 588.5L395.31 589.73L393.42 590.93L391.51 592.12L389.58 593.28L387.64 594.43L385.67 595.57L383.69 596.68L381.69 597.78L379.67 598.86L377.63 599.93L375.58 600.97L373.51 602L371.41 603.01L369.3 604.01L367.18 604.98L365.03 605.94L362.86 606.88L360.68 607.81L358.48 608.71L356.26 609.6L354.02 610.48L351.77 611.33L349.49 612.17L347.2 612.98L344.89 613.79L342.56 614.57L340.22 615.34L337.85 616.09L335.47 616.82L333.07 617.53L330.65 618.23L328.21 618.91L325.75 619.57L323.28 620.21L320.79 620.84L318.28 621.45L315.75 622.04L313 621.11L310.27 620.17L307.57 619.22L304.9 618.27L302.25 617.3L299.62 616.32L297.02 615.33L294.45 614.33L291.89 613.32L289.37 612.31L286.87 611.28L284.39 610.24L281.94 609.19L279.52 608.14L277.12 607.07L274.74 605.99L272.39 604.91L270.07 603.81L267.77 602.7L265.49 601.59L263.24 600.46L261.02 599.33L258.82 598.18L256.64 597.03L254.49 595.86L252.37 594.69L250.27 593.5L248.19 592.31L246.14 591.1L244.11 589.89L242.11 588.66L240.14 587.43L238.19 586.18L236.26 584.93L234.36 583.67L232.49 582.39L230.64 581.11L228.81 579.81L227.01 578.51L225.24 577.2L219.24 572.66L213.41 568.13L207.74 563.61L202.22 559.11L196.85 554.61L191.64 550.13L186.57 545.67L181.65 541.23L176.87 536.82L172.23 532.42L167.74 528.05L163.38 523.72L159.15 519.41L155.06 515.13L151.09 510.89L147.26 506.68L143.55 502.52L139.96 498.39L136.5 494.31L133.15 490.27L129.92 486.28L126.8 482.34L123.8 478.44L120.9 474.61L118.11 470.82L115.43 467.1L112.85 463.43L110.37 459.83L107.99 456.29L105.7 452.81L103.51 449.4L101.41 446.06L99.4 442.8L97.47 439.61L95.63 436.49L93.88 433.45L92.2 430.49L90.6 427.62L89.07 424.82L87.62 422.12L84 415.15L80.48 408.09L77.06 400.94L73.75 393.69L70.55 386.34L67.46 378.9L64.47 371.36L61.58 363.72L58.81 355.99L56.13 348.16L53.57 340.24L51.11 332.22L48.76 324.11L46.51 315.9L44.37 307.59L42.33 299.19L40.4 290.69L38.58 282.09L36.86 273.4L35.25 264.62L33.75 255.74L32.35 246.76L31.06 237.68L29.87 228.52L28.79 219.25L27.81 209.89L26.95 200.43L26.18 190.88L25.53 181.23L24.98 171.48L24.53 161.64L24.19 151.71L23.96 141.67L23.83 131.55L23.81 121.32L23.9 111L24.09 100.58L24.39 90.07L24.79 79.46L25.3 68.76L32.46 66.25L39.61 63.81L46.78 61.43L53.95 59.11L61.12 56.85L68.31 54.66L75.49 52.54L82.68 50.47L89.88 48.47L97.09 46.53L104.29 44.66L111.51 42.85L118.73 41.11L125.95 39.42L133.18 37.8L140.42 36.25L147.66 34.76L154.91 33.33L162.16 31.96L169.42 30.66L176.68 29.42L183.95 28.25L191.23 27.14L198.51 26.09L205.79 25.1L213.09 24.18L220.38 23.33L227.69 22.53L234.99 21.8L242.31 21.13L249.63 20.53L256.95 19.99L264.28 19.52L271.62 19.1L278.96 18.75L286.3 18.47L293.66 18.25L301.01 18.09L308.38 17.99L315.75 17.96L323.12 17.99L330.5 18.09ZM303.16 91.29L294.86 92.13L286.65 93.3L278.56 94.79L270.57 96.59L262.71 98.7L254.97 101.11L247.37 103.81L239.91 106.8L232.59 110.07L225.43 113.61L218.42 117.41L211.58 121.48L204.92 125.8L198.44 130.36L192.14 135.17L186.04 140.21L180.13 145.47L174.43 150.96L168.95 156.65L163.69 162.56L158.65 168.66L153.84 174.96L149.28 181.44L144.96 188.11L140.89 194.94L137.08 201.95L133.54 209.11L130.28 216.43L127.29 223.89L124.59 231.5L122.18 239.23L120.07 247.1L118.27 255.08L116.78 263.18L115.61 271.38L114.76 279.68L114.25 288.08L114.08 296.57L114.25 305.05L114.76 313.45L115.61 321.75L116.78 329.96L118.27 338.05L120.07 346.04L122.18 353.9L124.59 361.64L127.29 369.24L130.28 376.7L133.54 384.02L137.08 391.18L140.89 398.19L144.96 405.02L149.28 411.69L153.84 418.17L158.65 424.47L163.69 430.57L168.95 436.48L174.43 442.17L180.13 447.66L186.04 452.92L192.14 457.96L198.44 462.77L204.92 467.33L211.58 471.65L218.42 475.72L225.43 479.52L232.59 483.06L239.91 486.33L247.37 489.32L254.97 492.02L262.71 494.43L270.57 496.54L278.56 498.34L286.65 499.83L294.86 501L303.16 501.84L311.56 502.36L320.04 502.53L328.53 502.36L336.92 501.84L345.23 501L353.43 499.83L361.53 498.34L369.51 496.54L377.38 494.43L385.11 492.02L392.72 489.32L400.18 486.33L407.5 483.06L414.66 479.52L421.66 475.72L428.5 471.65L435.16 467.33L441.65 462.77L447.95 457.96L454.05 452.92L459.95 447.66L465.65 442.17L471.14 436.48L476.4 430.57L481.44 424.47L486.24 418.17L490.81 411.69L495.13 405.02L499.19 398.19L503 391.18L506.54 384.02L509.81 376.7L512.8 369.24L515.5 361.64L517.91 353.9L520.01 346.04L521.82 338.05L522.39 334.91L469.49 334.91L468.14 339.93L466.35 345.69L464.33 351.36L462.11 356.92L459.67 362.38L457.03 367.71L454.2 372.93L451.16 378.03L447.95 383L444.54 387.83L440.96 392.52L437.21 397.07L433.28 401.47L429.2 405.72L424.95 409.81L420.55 413.73L416 417.48L411.31 421.07L406.47 424.47L401.51 427.69L396.41 430.72L391.19 433.56L385.85 436.19L380.4 438.63L374.84 440.86L369.17 442.87L363.4 444.66L357.54 446.24L351.59 447.58L345.56 448.69L339.44 449.56L333.25 450.19L327 450.57L320.67 450.7L314.35 450.57L308.09 450.19L301.9 449.56L295.79 448.69L289.75 447.58L283.8 446.24L277.94 444.66L272.17 442.87L266.51 440.86L260.95 438.63L255.49 436.19L250.15 433.56L244.93 430.72L239.84 427.69L234.87 424.47L230.04 421.07L225.35 417.48L220.8 413.73L216.4 409.81L212.15 405.72L208.06 401.47L204.14 397.07L200.38 392.52L196.8 387.83L193.4 383L190.18 378.03L187.15 372.93L184.31 367.71L181.67 362.38L179.24 356.92L177.01 351.36L175 345.69L173.2 339.93L171.63 334.07L170.29 328.12L169.18 322.08L168.31 315.97L167.68 309.78L167.3 303.52L167.17 297.2L167.3 290.87L167.68 284.61L168.31 278.42L169.18 272.31L170.29 266.27L171.63 260.32L173.2 254.46L175 248.7L177.01 243.03L179.24 237.47L181.67 232.01L184.31 226.68L187.15 221.46L190.18 216.36L193.4 211.39L196.8 206.56L200.38 201.87L204.14 197.32L208.06 192.92L212.15 188.67L216.4 184.58L220.8 180.66L225.35 176.91L230.04 173.32L234.87 169.92L239.84 166.7L244.93 163.67L250.15 160.83L255.49 158.2L260.95 155.76L266.51 153.53L272.17 151.52L277.94 149.73L283.8 148.15L289.75 146.81L295.79 145.7L301.9 144.83L308.09 144.2L314.35 143.82L320.67 143.69L327 143.82L333.25 144.2L339.44 144.83L345.56 145.7L351.59 146.81L357.54 148.15L363.4 149.73L369.17 151.52L374.84 153.53L380.4 155.76L385.85 158.2L391.19 160.83L396.41 163.67L401.51 166.7L406.47 169.92L411.31 173.32L416 176.91L420.55 180.66L424.95 184.58L429.2 188.67L433.28 192.92L437.21 197.32L440.96 201.87L444.54 206.56L447.95 211.39L451.16 216.36L454.2 221.46L457.03 226.68L459.67 232.01L462.11 237.47L464.33 243.03L466.35 248.7L468.14 254.46L469.71 260.32L469.85 260.92L522.89 260.92L521.82 255.08L520.01 247.1L517.91 239.23L515.5 231.5L512.8 223.89L509.81 216.43L506.54 209.11L503 201.95L499.19 194.94L495.13 188.11L490.81 181.44L486.24 174.96L481.44 168.66L476.4 162.56L471.14 156.65L465.65 150.96L459.95 145.47L454.05 140.21L447.95 135.17L441.65 130.36L435.16 125.8L428.5 121.48L421.66 117.41L414.66 113.61L407.5 110.07L400.18 106.8L392.72 103.81L385.11 101.11L377.38 98.7L369.51 96.59L361.53 94.79L353.43 93.3L345.23 92.13L336.92 91.29L328.53 90.78L320.04 90.6L311.56 90.78L303.16 91.29ZM314.2 233.73L311.67 233.98L309.17 234.34L306.7 234.79L304.27 235.34L301.87 235.99L299.51 236.72L297.42 237.46L297.63 237.67L298.48 238.59L299.3 239.55L300.07 240.53L300.81 241.55L301.51 242.6L302.17 243.67L302.79 244.77L303.36 245.9L303.89 247.06L304.38 248.24L304.82 249.44L305.21 250.66L305.55 251.91L305.84 253.17L306.09 254.45L306.28 255.75L306.41 257.07L306.5 258.4L306.53 259.75L306.5 261.09L306.41 262.42L306.28 263.74L306.09 265.04L305.84 266.32L305.55 267.59L305.21 268.83L304.82 270.06L304.38 271.26L303.89 272.44L303.36 273.59L302.79 274.72L302.17 275.82L301.51 276.9L300.81 277.94L300.07 278.96L299.3 279.95L298.48 280.9L297.63 281.82L296.74 282.71L295.82 283.56L294.87 284.38L293.88 285.16L292.86 285.9L291.82 286.6L290.74 287.25L289.64 287.87L288.51 288.45L287.35 288.98L286.18 289.46L284.97 289.9L283.75 290.29L282.51 290.63L281.24 290.93L279.96 291.17L278.66 291.36L277.34 291.5L276.01 291.58L274.66 291.61L273.32 291.58L271.99 291.5L270.67 291.36L269.37 291.17L268.09 290.93L266.82 290.63L265.58 290.29L264.36 289.9L263.15 289.46L261.98 288.98L260.82 288.45L259.69 287.87L258.59 287.25L257.51 286.6L257.34 286.48L257.03 288.62L256.77 291.15L256.62 293.71L256.56 296.3L256.62 298.89L256.77 301.45L257.03 303.98L257.39 306.48L257.84 308.95L258.39 311.38L259.03 313.78L259.77 316.14L260.59 318.45L261.5 320.73L262.5 322.96L263.58 325.14L264.74 327.28L265.98 329.36L267.29 331.39L268.68 333.37L270.15 335.29L271.69 337.15L273.29 338.95L274.96 340.69L276.7 342.36L278.5 343.96L280.36 345.5L282.28 346.96L284.25 348.35L286.29 349.67L288.37 350.91L290.51 352.07L292.69 353.15L294.92 354.15L297.19 355.06L299.51 355.88L301.87 356.61L304.27 357.26L306.7 357.81L309.17 358.26L311.67 358.62L314.2 358.87L316.76 359.03L319.35 359.08L321.93 359.03L324.49 358.87L327.02 358.62L329.52 358.26L331.99 357.81L334.43 357.26L336.82 356.61L339.18 355.88L341.5 355.06L343.77 354.15L346.01 353.15L348.19 352.07L350.32 350.91L352.41 349.67L354.44 348.35L356.42 346.96L358.33 345.5L360.2 343.96L362 342.36L363.73 340.69L365.4 338.95L367.01 337.15L368.54 335.29L370.01 333.37L371.4 331.39L372.72 329.36L373.96 327.28L375.12 325.14L376.2 322.96L377.19 320.73L378.1 318.45L378.93 316.14L379.66 313.78L380.3 311.38L380.85 308.95L381.31 306.48L381.66 303.98L381.92 301.45L382.08 298.89L382.13 296.3L382.08 293.71L381.92 291.15L381.66 288.62L381.31 286.12L380.85 283.65L380.3 281.22L379.66 278.82L378.93 276.47L378.1 274.15L377.19 271.87L376.2 269.64L375.12 267.46L373.96 265.32L372.72 263.24L371.4 261.21L370.01 259.23L368.54 257.31L367.01 255.45L365.4 253.65L363.73 251.92L362 250.24L360.2 248.64L358.33 247.1L356.42 245.64L354.44 244.25L352.41 242.93L350.32 241.69L348.19 240.53L346.01 239.45L343.77 238.46L341.5 237.54L339.18 236.72L336.82 235.99L334.43 235.34L331.99 234.79L329.52 234.34L327.02 233.98L324.49 233.73L321.93 233.57L319.35 233.52L316.76 233.57L314.2 233.73Z" id="fITBbomu"></path></defs><g><g><g><g><use xlink:href="#fITBbomu" opacity="1" fill="#ffffff" fill-opacity="1"></use><g><use xlink:href="#fITBbomu" opacity="1" fill-opacity="1" stroke="#000000" stroke-width="0" stroke-opacity="1"></use></g></g></g></g></g></svg>
    </template>
    <template v-else-if="icon === 'location'">
      <svg fill="#FFFFFF" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
        <path d="M0 0h24v24H0z" fill="none"/>
      </svg>
    </template>
    <template v-else-if="icon === 'network'">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <path fill-opacity=".3" d="M2 22h20V2z"/>
        <path d="M17 7L2 22h15z"/>
        <path d="M0 0h24v24H0z" fill="none"/>
      </svg>
    </template>
    <template v-else-if="icon === 'dvr'">
      <svg fill="#FFFFFF" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 0h24v24H0z" fill="none"/>
        <path d="M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.1-.9-2-2-2zm0 14H3V5h18v12zm-2-9H8v2h11V8zm0 4H8v2h11v-2zM7 8H5v2h2V8zm0 4H5v2h2v-2z"/>
      </svg>
    </template>
    <template v-else-if="icon === 'person'">
      <svg fill="#FFFFFF" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
        <path d="M0 0h24v24H0z" fill="none"/>
      </svg>
    </template>
    <template v-else-if="icon === 'contentCopy'">
      <svg fill="#FFFFFF" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 0h24v24H0z" fill="none"/>
        <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"/>
      </svg>
    </template>
    <template v-else-if="icon === 'error'">
      <svg fill="#000000" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 0h24v24H0z" fill="none"/>
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
      </svg>
    </template>
    <template v-else-if="icon === 'warning'">
      <svg fill="#000000" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 0h24v24H0z" fill="none"/>
        <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>
      </svg>
    </template>
    <template v-else-if="icon === 'verifiedUser'">
      <svg fill="#000000" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 0h24v24H0z" fill="none"/>
        <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"/>
      </svg>
    </template>
    <template v-else-if="icon === 'notificationsActive'">
      <svg fill="#000000" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 0h24v24H0z" fill="none"/>
        <path d="M7.58 4.08L6.15 2.65C3.75 4.48 2.17 7.3 2.03 10.5h2c.15-2.65 1.51-4.97 3.55-6.42zm12.39 6.42h2c-.15-3.2-1.73-6.02-4.12-7.85l-1.42 1.43c2.02 1.45 3.39 3.77 3.54 6.42zM18 11c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2v-5zm-6 11c.14 0 .27-.01.4-.04.65-.14 1.18-.58 1.44-1.18.1-.24.15-.5.15-.78h-4c.01 1.1.9 2 2.01 2z"/>
      </svg>
    </template>
    <template v-else-if="icon === 'notifications'">
      <svg fill="#FFFFFF" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"/>
      </svg>
    </template>
    <template v-else-if="icon === 'list'">
      <svg fill="#FFFFFF" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z"/>
        <path d="M0 0h24v24H0z" fill="none"/>
      </svg>
    </template>
    <template v-else-if="icon === 'close'">
      <svg fill="#FFFFFF" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
        <path d="M0 0h24v24H0z" fill="none"/>
      </svg>
    </template>
    <template v-else-if="icon === 'face'">
      <svg fill="#FFFFFF" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 11.75c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zm6 0c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8 0-.29.02-.58.05-.86 2.36-1.05 4.23-2.98 5.21-5.37C11.07 8.33 14.05 10 17.42 10c.78 0 1.53-.09 2.25-.26.21.71.33 1.47.33 2.26 0 4.41-3.59 8-8 8z"/>
        <path d="M0 0h24v24H0z" fill="none"/>
      </svg>
    </template>
    <template v-else-if="icon === 'pause'">
      <svg fill="#FFFFFF" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/>
        <path d="M0 0h24v24H0z" fill="none"/>
      </svg>
    </template>
    <template v-else-if="icon === 'info'">
      <svg fill="#FFFFFF" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 0h24v24H0z" fill="none"/>
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
      </svg>
    </template>
    <template v-else-if="icon === 'videocam' || icon === 'camera'">
      <svg fill="#FFFFFF" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 0h24v24H0z" fill="none"/>
        <path d="M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z"/>
      </svg>
    </template>
    <template v-else-if="icon === 'refresh'">
      <svg fill="#FFFFFF" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
        <path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"/>
        <path d="M0 0h24v24H0z" fill="none"/>
      </svg>
    </template>
    <template v-else-if="icon === 'volumeOff'">
      <svg fill="#FFFFFF" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"/>
        <path d="M0 0h24v24H0z" fill="none"/>
      </svg>
    </template>
    <template v-else-if="icon === 'volumeUp'">
      <svg fill="#FFFFFF" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/>
        <path d="M0 0h24v24H0z" fill="none"/>
      </svg>
    </template>
    <template v-else-if="icon === 'play'">
      <svg fill="#FFFFFF" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 5v14l11-7z"/>
        <path d="M0 0h24v24H0z" fill="none"/>
      </svg>
    </template>
    <template v-else-if="icon === 'forward10'">
      <svg fill="#FFFFFF" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <defs>
          <path d="M24 24H0V0h24v24z" id="a"/>
        </defs>
        <clipPath id="b">
          <use overflow="visible" xlink:href="#a"/>
        </clipPath>
        <path clip-path="url(#b)" d="M4 13c0 4.4 3.6 8 8 8s8-3.6 8-8h-2c0 3.3-2.7 6-6 6s-6-2.7-6-6 2.7-6 6-6v4l5-5-5-5v4c-4.4 0-8 3.6-8 8zm6.8 3H10v-3.3L9 13v-.7l1.8-.6h.1V16zm4.3-1.8c0 .3 0 .6-.1.8l-.3.6s-.3.3-.5.3-.4.1-.6.1-.4 0-.6-.1-.3-.2-.5-.3-.2-.3-.3-.6-.1-.5-.1-.8v-.7c0-.3 0-.6.1-.8l.3-.6s.3-.3.5-.3.4-.1.6-.1.4 0 .6.1.3.2.5.3.2.3.3.6.1.5.1.8v.7zm-.8-.8v-.5s-.1-.2-.1-.3-.1-.1-.2-.2-.2-.1-.3-.1-.2 0-.3.1l-.2.2s-.1.2-.1.3v2s.1.2.1.3.1.1.2.2.2.1.3.1.2 0 .3-.1l.2-.2s.1-.2.1-.3v-1.5z"/>
      </svg>
    </template>
    <template v-else-if="icon === 'replay10'">
      <svg fill="#FFFFFF" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <defs>
          <path d="M0 0h24v24H0V0z" id="a"/>
        </defs>
        <clipPath id="b">
          <use overflow="visible" xlink:href="#a"/>
        </clipPath>
        <path clip-path="url(#b)" d="M12 5V1L7 6l5 5V7c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6H4c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8zm-1.1 11H10v-3.3L9 13v-.7l1.8-.6h.1V16zm4.3-1.8c0 .3 0 .6-.1.8l-.3.6s-.3.3-.5.3-.4.1-.6.1-.4 0-.6-.1-.3-.2-.5-.3-.2-.3-.3-.6-.1-.5-.1-.8v-.7c0-.3 0-.6.1-.8l.3-.6s.3-.3.5-.3.4-.1.6-.1.4 0 .6.1c.2.1.3.2.5.3s.2.3.3.6.1.5.1.8v.7zm-.9-.8v-.5s-.1-.2-.1-.3-.1-.1-.2-.2-.2-.1-.3-.1-.2 0-.3.1l-.2.2s-.1.2-.1.3v2s.1.2.1.3.1.1.2.2.2.1.3.1.2 0 .3-.1l.2-.2s.1-.2.1-.3v-1.5z"/>
      </svg>
    </template>
    <template v-else-if="icon === 'arrowDropDown'">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <path d="M7 10l5 5 5-5z"/>
        <path d="M0 0h24v24H0z" fill="none"/>
      </svg>
    </template>
    <template v-else-if="icon === 'arrowUp'">
      <svg fill="#FFFFFF" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"/>
        <path d="M0 0h24v24H0z" fill="none"/>
      </svg>
    </template>
    <template v-else-if="icon === 'arrowDown'">
      <svg fill="#FFFFFF" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"/>
        <path d="M0-.75h24v24H0z" fill="none"/>
      </svg>
    </template>
    <template v-else-if="icon === 'outlinePerson'">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12 5.9c1.16 0 2.1.94 2.1 2.1s-.94 2.1-2.1 2.1S9.9 9.16 9.9 8s.94-2.1 2.1-2.1m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z"/><path d="M0 0h24v24H0z" fill="none"/></svg>
    </template>
    <template v-else-if="icon === 'outlineLock'">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none"><path d="M0 0h24v24H0V0z"/><path opacity=".87" d="M0 0h24v24H0V0z"/></g><path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"/></svg>
    </template>
    <template v-else-if="icon === 'outlineMail'">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="none" d="M0 0h24v24H0V0z"/><path d="M22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6zm-2 0l-8 4.99L4 6h16zm0 12H4V8l8 5 8-5v10z"/></svg>
    </template>
    <template v-else-if="icon === 'menu'">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M0 0h24v24H0z" fill="none"/><path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"/></svg>
    </template>
    <template v-else-if="icon === 'mail'">
      <svg fill="#FFFFFF" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
        <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
        <path d="M0 0h24v24H0z" fill="none"/>
      </svg>
    </template>
    <template v-else-if="icon === 'map'">
      <svg fill="#FFFFFF" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
        <path d="M20.5 3l-.16.03L15 5.1 9 3 3.36 4.9c-.21.07-.36.25-.36.48V20.5c0 .28.22.5.5.5l.16-.03L9 18.9l6 2.1 5.64-1.9c.21-.07.36-.25.36-.48V3.5c0-.28-.22-.5-.5-.5zM15 19l-6-2.11V5l6 2.11V19z"/>
        <path d="M0 0h24v24H0z" fill="none"/>
      </svg>
    </template>
    <template v-else-if="icon === 'phoneSpeaker'">
      <svg fill="#FFFFFF" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 0h24v24H0V0zm0 0h24v24H0V0z" fill="none"/>
        <path d="M7 7.07L8.43 8.5c.91-.91 2.18-1.48 3.57-1.48s2.66.57 3.57 1.48L17 7.07C15.72 5.79 13.95 5 12 5s-3.72.79-5 2.07zM12 1C8.98 1 6.24 2.23 4.25 4.21l1.41 1.41C7.28 4 9.53 3 12 3s4.72 1 6.34 2.62l1.41-1.41C17.76 2.23 15.02 1 12 1zm2.86 9.01L9.14 10C8.51 10 8 10.51 8 11.14v9.71c0 .63.51 1.14 1.14 1.14h5.71c.63 0 1.14-.51 1.14-1.14v-9.71c.01-.63-.5-1.13-1.13-1.13zM15 20H9v-8h6v8z"/>
      </svg>
    </template>
    <template v-else-if="icon === 'dashboard'">
      <svg fill="#FFFFFF" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 0h24v24H0z" fill="none"/>
        <path d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z"/>
      </svg>
    </template>
    <template v-else-if="icon === 'store'">
      <svg fill="#FFFFFF" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 0h24v24H0z" fill="none"/>
        <path d="M20 4H4v2h16V4zm1 10v-2l-1-5H4l-1 5v2h1v6h10v-6h4v6h2v-6h1zm-9 4H6v-4h6v4z"/>
      </svg>
    </template>
    <template v-else-if="icon === 'zoomOut'">
      <svg fill="#FFFFFF" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 0h24v24H0V0z" fill="none"/>
        <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zM7 9h5v1H7z"/>
      </svg>
    </template>
    <template v-else-if="icon === 'zoomIn'">
      <svg fill="#FFFFFF" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
        <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
        <path d="M0 0h24v24H0V0z" fill="none"/>
        <path d="M12 10h-2v2H9v-2H7V9h2V7h1v2h2v1z"/>
      </svg>
    </template>
    <template v-else-if="icon === 'search'">
      <svg fill="#FFFFFF" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
        <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
        <path d="M0 0h24v24H0z" fill="none"/>
      </svg>
    </template>
    <template v-else-if="icon === 'phoneMessage'">
      <svg fill="#FFFFFF" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 0h24v24H0z" fill="none"/>
        <path d="M20 15.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.58l2.2-2.21c.28-.27.36-.66.25-1.01C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM12 3v10l3-3h6V3h-9z"/>
      </svg>
    </template>
    <template v-else-if="icon === 'replay'">
      <svg fill="#FFFFFF" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 0h24v24H0z" fill="none"/>
        <path d="M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z"/>
      </svg>
    </template>
    <template v-else-if="icon === 'mic'">
      <svg fill="#FFFFFF" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 14c1.66 0 2.99-1.34 2.99-3L15 5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z"/>
        <path d="M0 0h24v24H0z" fill="none"/>
      </svg>
    </template>
    <template v-else-if="icon === 'business'">
      <svg fill="#FFFFFF" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 0h24v24H0z" fill="none"/>
        <path d="M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"/>
      </svg>
    </template>
    <template v-else-if="icon === 'people'">
      <svg fill="#FFFFFF" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 0h24v24H0z" fill="none"/>
        <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/>
      </svg>
    </template>
    <template v-else-if="icon === 'firstPage'">
      <svg fill="#FFFFFF" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
        <path d="M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"/>
        <path d="M24 24H0V0h24v24z" fill="none"/>
      </svg>
    </template>
    <template v-else-if="icon === 'lastPage'">
      <svg fill="#FFFFFF" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"/>
        <path d="M0 0h24v24H0V0z" fill="none"/>
      </svg>
    </template>
    <template v-else-if="icon === 'before'">
      <svg fill="#FFFFFF" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
        <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/>
        <path d="M0 0h24v24H0z" fill="none"/>
      </svg>
    </template>
    <template v-else-if="icon === 'next'">
      <svg fill="#FFFFFF" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/>
        <path d="M0 0h24v24H0z" fill="none"/>
      </svg>
    </template>
    <template v-else-if="icon === 'link'">
      <svg fill="#FFFFFF" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 0h24v24H0z" fill="none"/>
        <path d="M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z"/>
      </svg>
    </template>
    <template v-else-if="icon === 'idcard'">
      <svg fill="#FFFFFF" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
        <path d="M21 8V7l-3 2-3-2v1l3 2 3-2zm1-5H2C.9 3 0 3.9 0 5v14c0 1.1.9 2 2 2h20c1.1 0 1.99-.9 1.99-2L24 5c0-1.1-.9-2-2-2zM8 6c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H2v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1z"/>
      </svg>
    </template>
    <template v-else-if="icon === 'spinnerTail'">
      <svg width="38" height="38" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient x1="8.042%" y1="0%" x2="65.682%" y2="23.865%" id="a">
            <stop stop-color="#fff" stop-opacity="0" offset="0%"/>
            <stop stop-color="#fff" stop-opacity=".631" offset="63.146%"/>
            <stop stop-color="#fff" offset="100%"/>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <g transform="translate(1 1)">
            <path d="M36 18c0-9.94-8.06-18-18-18" id="Oval-2" stroke="url(#a)" stroke-width="2">
              <animateTransform
                attributeName="transform"
                type="rotate"
                from="0 18 18"
                to="360 18 18"
                dur="0.9s"
                repeatCount="indefinite" />
            </path>
            <circle fill="#fff" cx="36" cy="18" r="1">
              <animateTransform
                attributeName="transform"
                type="rotate"
                from="0 18 18"
                to="360 18 18"
                dur="0.9s"
                repeatCount="indefinite" />
            </circle>
          </g>
        </g>
      </svg>
    </template>
    <template v-else-if="icon === 'spinnerBars'">
      <svg width="135" height="140" viewBox="0 0 135 140" xmlns="http://www.w3.org/2000/svg" fill="#fff">
        <rect y="10" width="15" height="120" rx="6">
          <animate attributeName="height"
            begin="0.5s" dur="1s"
            values="120;110;100;90;80;70;60;50;40;140;120" calcMode="linear"
            repeatCount="indefinite" />
          <animate attributeName="y"
            begin="0.5s" dur="1s"
            values="10;15;20;25;30;35;40;45;50;0;10" calcMode="linear"
            repeatCount="indefinite" />
        </rect>
        <rect x="30" y="10" width="15" height="120" rx="6">
          <animate attributeName="height"
            begin="0.25s" dur="1s"
            values="120;110;100;90;80;70;60;50;40;140;120" calcMode="linear"
            repeatCount="indefinite" />
          <animate attributeName="y"
            begin="0.25s" dur="1s"
            values="10;15;20;25;30;35;40;45;50;0;10" calcMode="linear"
            repeatCount="indefinite" />
        </rect>
        <rect x="60" width="15" height="140" rx="6">
          <animate attributeName="height"
            begin="0s" dur="1s"
            values="120;110;100;90;80;70;60;50;40;140;120" calcMode="linear"
            repeatCount="indefinite" />
          <animate attributeName="y"
            begin="0s" dur="1s"
            values="10;15;20;25;30;35;40;45;50;0;10" calcMode="linear"
            repeatCount="indefinite" />
        </rect>
        <rect x="90" y="10" width="15" height="120" rx="6">
          <animate attributeName="height"
            begin="0.25s" dur="1s"
            values="120;110;100;90;80;70;60;50;40;140;120" calcMode="linear"
            repeatCount="indefinite" />
          <animate attributeName="y"
            begin="0.25s" dur="1s"
            values="10;15;20;25;30;35;40;45;50;0;10" calcMode="linear"
            repeatCount="indefinite" />
        </rect>
        <rect x="120" y="10" width="15" height="120" rx="6">
          <animate attributeName="height"
            begin="0.5s" dur="1s"
            values="120;110;100;90;80;70;60;50;40;140;120" calcMode="linear"
            repeatCount="indefinite" />
          <animate attributeName="y"
            begin="0.5s" dur="1s"
            values="10;15;20;25;30;35;40;45;50;0;10" calcMode="linear"
            repeatCount="indefinite" />
        </rect>
      </svg>
    </template>
    <template v-else-if="icon === 'spinnerOval'">
      <svg width="38" height="38" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" stroke="#fff">
        <g fill="none" fill-rule="evenodd">
          <g transform="translate(1 1)" stroke-width="2">
            <circle stroke-opacity=".5" cx="18" cy="18" r="18"/>
            <path d="M36 18c0-9.94-8.06-18-18-18">
              <animateTransform
                attributeName="transform"
                type="rotate"
                from="0 18 18"
                to="360 18 18"
                dur="1s"
                repeatCount="indefinite"/>
            </path>
          </g>
        </g>
      </svg>
    </template>
    <template v-else-if="icon === 'spinnerPuff'">
      <svg width="44" height="44" viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg" stroke="#fff">
        <g fill="none" fill-rule="evenodd" stroke-width="2">
          <circle cx="22" cy="22" r="1">
            <animate attributeName="r"
              begin="0s" dur="1.8s"
              values="1; 20"
              calcMode="spline"
              keyTimes="0; 1"
              keySplines="0.165, 0.84, 0.44, 1"
              repeatCount="indefinite" />
            <animate attributeName="stroke-opacity"
              begin="0s" dur="1.8s"
              values="1; 0"
              calcMode="spline"
              keyTimes="0; 1"
              keySplines="0.3, 0.61, 0.355, 1"
              repeatCount="indefinite" />
          </circle>
          <circle cx="22" cy="22" r="1">
            <animate attributeName="r"
              begin="-0.9s" dur="1.8s"
              values="1; 20"
              calcMode="spline"
              keyTimes="0; 1"
              keySplines="0.165, 0.84, 0.44, 1"
              repeatCount="indefinite" />
            <animate attributeName="stroke-opacity"
              begin="-0.9s" dur="1.8s"
              values="1; 0"
              calcMode="spline"
              keyTimes="0; 1"
              keySplines="0.3, 0.61, 0.355, 1"
              repeatCount="indefinite" />
          </circle>
        </g>
      </svg>
    </template>
    <template v-else-if="icon === 'arrow-left'">
      <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 24 20" width="18px">
        <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/>
      </svg>
    </template>
    <template v-else-if="icon === 'eye'">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18px" fill="var(--blue-gray-high)">
        <path d="M0 0h24v24H0z" fill="none"/>
        <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/>
      </svg>
    </template>
    <template v-else-if="icon === 'eye-off'">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18px" fill="var(--blue-gray-high)">
        <path d="M0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0z" fill="none"/>
        <path d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"/>
      </svg>
    </template>
    <template v-else-if="icon === 'check'">
    <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" viewBox="0 0 24 24" width="18px" fill="var(--success)"><rect fill="none" height="24" width="24"/>
      <path d="M22,5.18L10.59,16.6l-4.24-4.24l1.41-1.41l2.83,2.83l10-10L22,5.18z M19.79,10.22C19.92,10.79,20,11.39,20,12 c0,4.42-3.58,8-8,8s-8-3.58-8-8c0-4.42,3.58-8,8-8c1.58,0,3.04,0.46,4.28,1.25l1.44-1.44C16.1,2.67,14.13,2,12,2C6.48,2,2,6.48,2,12 c0,5.52,4.48,10,10,10s10-4.48,10-10c0-1.19-0.22-2.33-0.6-3.39L19.79,10.22z"/>
    </svg>
    </template>
    <template v-else>
      <svg fill="#FFFFFF" height="48" viewBox="0 0 24 24" width="48" xmlns="http://www.w3.org/2000/svg">
        <path d="M24 24H0V0h24v24z" fill="none"/>
        <circle cx="12" cy="12" r="8"/>
      </svg>
    </template>
  </div>
</template>

<script>
export default {
  name: 'comp-icon',
  props: {
    icon: {
      type: String,
      default: function () {
        return null
      }
    },
    width: {
      type: Number,
      default: function () {
        return 40
      }
    },
    widthInCustomMetric: {
      type: String,
      default: function () {
        return null
      }
    },
    color: {
      type: String,
      default: function () {
        return null
      }
    }
  }
}
</script>

<style scoped>
.comp-icon {
  /* size */
  width: 1em;
  height: 1em;
  /* position */
  position: relative;
}

.comp-icon svg{
  /* common */
  fill: currentColor;
  /* size */
  width: 0.9em;
  height: 0.9em;
  /* position */
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>



// WEBPACK FOOTER //
// src/components/CompIcon.vue